import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

export const FAQ_ITEMS = [
  {
    q: "What does a paystub include?",
    a: "Enter your own earnings, hours, pay rate, deductions, and state taxes so your statement reflects your actual pay. A Nexus Numbers earnings statement includes employee and employer details, the pay period and paycheck date, itemized earnings (hours and pay rates), gross pay, taxes withheld (federal, Social Security, Medicare, and state), deductions such as medical insurance and 401(k), and the resulting net pay — plus year-to-date totals.",
  },
  {
    q: "Who is this for?",
    a: "It is built for small business owners, freelancers, and the self-employed who need accurate, print-ready earnings statements for their own records. Statements must reflect actual wages that were genuinely paid.",
  },
  {
    q: "How do revisions work?",
    a: "Your $10 fee includes generation plus one free revision. After you generate a statement you can edit the details once and regenerate the PDF at no extra cost. Additional revisions require a new order.",
  },
  {
    q: "How does payment work?",
    a: "Checkout is a flat $10.00 USD handled securely by PayPal — pay with your PayPal balance or a debit/credit card. The watermark-free PDF unlocks only after your payment is confirmed as completed.",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="border-t border-[#D0E2FF]/60 bg-white scroll-mt-24">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
        <h2 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight text-[#0F172A]">
          Frequently asked questions
        </h2>
        <p className="text-[#475569] mt-2 mb-8">Everything you need to know before you create a statement.</p>
        <div className="space-y-3">
          {FAQ_ITEMS.map((item, i) => (
            <div key={i} className="rounded-xl border border-[#D0E2FF] bg-white overflow-hidden">
              <button
                data-testid={`faq-toggle-${i}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <span className="font-semibold text-[#0F172A]">{item.q}</span>
                <ChevronDown
                  className={`w-5 h-5 text-[#2563EB] shrink-0 transition-transform duration-300 ${open === i ? "rotate-180" : ""}`}
                />
              </button>
              {open === i && (
                <div className="px-5 pb-5 text-sm leading-relaxed text-[#475569]">{item.a}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
